import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from '../context/AuthContext';
import Header from './Header'
import api from '../api/client';
import './CreateCard.css';

const CATEGORIES = [
    'categories.painting',
    'categories.digital',
    'categories.photography',
    'categories.sculpture',
    'categories.drawing',
    'categories.mixedMedia'
];

export default function CreateCard({ translations }) {
    let navigate = useNavigate();
    const { user } = useAuth();
    const fileRef = useRef(null);
    const [title, setTitle] = useState('');
    const [price, setPrice] = useState('');
    const [description, setDescription] = useState('');
    const [category, setCategory] = useState('Painting');
    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleFileChange = (e) => {
        const f = e.target.files?.[0];
        if (!f) return;
        setFile(f);
        const url = URL.createObjectURL(f);
        setPreview(url);
    };

    const handleCardSubmit = async (e) => {
        e.preventDefault();
        if (!file) {
            setError(translations['create-card-error-no-file']);
            return;
        }
        setError('');
        setLoading(true);
        try {
            const result = await api.uploadPicture(file, {
                title: title || undefined,
                description,
                price: price ? Number(price) : undefined,
                category,
            });
            navigate(`/picture/${result.publicId}`);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }

    if (user?.userType !== 'artist') {
        return (
            <>
                <Header translations={translations} />
                <div className="create-card-gate">
                    <span className="create-card-gate-icon">🔒</span>
                    <h2 className="create-card-gate-title">
                        {translations['create-card-not-artist-title'] || 'Verify your identity to post'}
                    </h2>
                    <p className="create-card-gate-text">
                        {translations['create-card-not-artist-text'] ||
                            'Only verified artists can upload artworks. Verify your identity to unlock posting.'}
                    </p>
                    <button className="btn create-card-gate-btn" onClick={() => navigate('/verify-identity')}>
                        {translations['create-card-not-artist-cta'] || 'Verify my identity'}
                    </button>
                </div>
            </>
        );
    }

    return (
        <>
            <Header translations={translations} />
            <h2 className="create-card-title">{translations['create-card-title']}</h2>
            <div className="upload-content">
                <div className='upload-left'>
                    <div className="upload-dropzone" onClick={() => fileRef.current?.click()}>
                        {preview ? (
                            <img src={preview} alt="Preview" className="upload-preview" />
                        ) : (
                        <div className="upload-placeholder">
                            <span className="upload-icon">+</span>
                            <p>{translations['create-card-upload-image']}</p>
                            <span className="upload-hint">JPG, PNG, WebP, HEIC, AVIF - Max 120MB</span>
                        </div>
                        )}
                        <input ref={fileRef} type="file" accept="image/*" hidden onChange={handleFileChange} />
                    </div>
                </div>
                <div className='upload-right'>
                    <div className='inputs'>
                        <input type='text' value={title} onChange={(e) => setTitle(e.target.value)} placeholder={translations['create-card-title-placeholder']} className='input-text'></input>
                        <input type='text' value={price} onChange={(e) => setPrice(e.target.value)} placeholder={translations['create-card-price-placeholder']} className='input-text'></input>
                        <input type='text' value={description} onChange={(e) => setDescription(e.target.value)} placeholder={translations['create-card-description-placeholder']} className='input-text'></input>
                        <select
                            className="select-category"
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                        >
                        {CATEGORIES.map((cat) => {
                            const key = cat.split('.')[1];

                            return (
                                <option key={cat} value={cat}>
                                    {translations.categories?.[key] || cat}
                                </option>
                            );
                        })}
                        </select>
                    </div>

                    {error && <p className="error-text">{error}</p>}

                    <button className='btn create-card-btn' onClick={handleCardSubmit} disabled={loading}>
                        {loading ? translations['create-card-loading'] : translations['create-card-button']}
                    </button>
                </div>
            </div>
        </>
    );
}
